import { useId } from "react";

import { cn } from "@/lib/utils";

export function ClaimedIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("size-4.5", className)}
      viewBox="0 0 18 19"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.7.612a.457.457 0 01.6 0l1.52 1.32c.107.092.25.13.387.103l1.977-.382a.457.457 0 01.52.3l.657 1.903c.046.133.15.237.283.283l1.903.657a.457.457 0 01.3.52l-.382 1.977a.457.457 0 00.104.386l1.32 1.521a.46.46 0 010 .6l-1.32 1.52a.457.457 0 00-.104.387l.382 1.977a.457.457 0 01-.3.52l-1.903.657a.457.457 0 00-.283.283l-.657 1.903a.457.457 0 01-.52.3l-1.977-.382a.457.457 0 00-.386.104L9.3 18.389a.457.457 0 01-.6 0l-1.52-1.32a.457.457 0 00-.387-.104l-1.977.382a.457.457 0 01-.52-.3l-.657-1.903a.457.457 0 00-.283-.283l-1.903-.657a.457.457 0 01-.3-.52l.382-1.977a.457.457 0 00-.103-.386L.112 9.8a.457.457 0 010-.6l1.32-1.52a.457.457 0 00.103-.387l-.382-1.977a.457.457 0 01.3-.52l1.903-.657a.457.457 0 00.283-.283l.657-1.903a.457.457 0 01.52-.3l1.977.382a.457.457 0 00.386-.103L8.7.612z"
        fill={`url(#${id})`}
      />
      <path
        clipRule="evenodd"
        d="M13.181 6.596a.875.875 0 01.073 1.235l-4.8 5.4a.875.875 0 01-1.308 0l-2.4-2.7A.875.875 0 116.054 9.37L7.8 11.333l4.146-4.664a.875.875 0 011.235-.073z"
        fill="#fff"
        fillRule="evenodd"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={id}
          x1="0.675"
          x2="7.679"
          y1="0.5"
          y2="0.794"
        >
          <stop stopColor="#00b7d8" />
          <stop offset="1" stopColor="#008ad8" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function InfoIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-4 text-heather", className)}
      viewBox="0 0 16 17"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M8 .5c-4.416 0-8 3.584-8 8s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8zm0 13.143c-.503 0-.915-.514-.915-1.143V7.929c0-.629.412-1.143.914-1.143.503 0 .915.514.915 1.143V12.5c0 .629-.412 1.143-.915 1.143zM7.251 5.48c.374.375 1.133.365 1.498 0s.375-1.124 0-1.499c-.374-.375-1.124-.375-1.498 0-.375.375-.375 1.124 0 1.499z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function PartnerIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("size-8.5", className)}
      fill="none"
      viewBox="0 0 34 34"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.434.211a.864.864 0 011.132 0l2.873 2.493c.2.174.47.246.73.196l3.735-.722c.422-.082.84.16.98.566l1.242 3.595c.087.25.284.448.535.535l3.595 1.241c.407.14.648.559.567.981l-.723 3.735c-.05.26.022.53.196.73l2.493 2.873a.864.864 0 010 1.132l-2.493 2.873a.864.864 0 00-.196.73l.723 3.735a.864.864 0 01-.567.98l-3.595 1.242a.864.864 0 00-.535.535l-1.241 3.595a.864.864 0 01-.981.567l-3.735-.723a.864.864 0 00-.73.196l-2.873 2.493a.864.864 0 01-1.132 0l-2.873-2.493a.864.864 0 00-.73-.196l-3.735.723a.864.864 0 01-.98-.567l-1.242-3.595a.864.864 0 00-.535-.535l-3.595-1.241a.864.864 0 01-.566-.981l.722-3.735a.864.864 0 00-.196-.73L.211 17.566a.864.864 0 010-1.132l2.493-2.873c.174-.2.246-.47.196-.73l-.722-3.735a.864.864 0 01.566-.98l3.595-1.242a.864.864 0 00.535-.535l1.241-3.595a.864.864 0 01.981-.566l3.735.722c.26.05.53-.022.73-.196L16.434.211z"
        fill={`url(#${id})`}
      />
      <path
        clipRule="evenodd"
        d="M24.898 11.515c.682.606.743 1.65.137 2.333l-9.067 10.2a1.652 1.652 0 01-2.47 0l-4.534-5.1a1.653 1.653 0 112.471-2.196l3.298 3.71 7.831-8.81a1.653 1.653 0 012.334-.137z"
        fill="#fff"
        fillRule="evenodd"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={id}
          x1="3.023"
          x2="32.82"
          y1="32.044"
          y2="21.801"
        >
          <stop stopColor="#6315ea" />
          <stop offset="1" stopColor="#ef67b0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
